var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{staticClass:"tool-tips",attrs:{"effect":"dark","placement":"right"}},[_c('div',{staticClass:"tool-tips-content",attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.tips))]),_vm._v(" "),_c('i',{staticClass:"el-icon-question"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a366e9f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basics/lbToolTips.vue
// module id = null
// module chunks = 